import { useLocation } from 'wouter';

/**
 * Voltar de uma página de habilidade (Contas, Clima, Lista...): para o palco, de
 * onde a pessoa veio (Hoje, painel ou voz).
 */
export function useSkillBack(): () => void {
  const [, setLocation] = useLocation();
  return () => setLocation('/');
}
